enum Keyword{
    If='IF'
}

export default Keyword;